const routeExists = (routes, path) => routes.some((route) => route.path === path);
const leaf = (id, path, label, options = {}) => ({ id, path, label, kind: "leaf", ...options });
const category = (id, label, children = [], options = {}) => ({ id, path: children[0]?.path ?? `/${id}`, label, kind: "category", children, ...options });

export const buildPrivateSidebarNavigation = ({ routes = [] } = {}) => {
    const sections = [];

    const portal = [];
    if (routeExists(routes, "/instructor")) portal.push(leaf("instructorDashboard", "/instructor", "Panel"));
    if (routeExists(routes, "/instructor/cohorts")) portal.push(leaf("instructorCohorts", "/instructor/cohorts", "Mis comisiones", { match: "prefix" }));
    if (routeExists(routes, "/instructor/calendar")) portal.push(leaf("instructorCalendar", "/instructor/calendar", "Calendario"));
    if (routeExists(routes, "/student")) portal.push(leaf("student", "/student", "Mis cursos"));
    if (routeExists(routes, "/student/certificates")) portal.push(leaf("studentCertificates", "/student/certificates", "Mis certificados"));
    if (routeExists(routes, "/student/catalog")) portal.push(leaf("studentCatalog", "/student/catalog", "Explorar cursos"));
    if (routeExists(routes, "/notifications")) portal.push(leaf("notifications", "/notifications", "Notificaciones"));
    if (routeExists(routes, "/policies")) portal.push(leaf("policies", "/policies", "Políticas"));
    if (portal.length) sections.push(category("portal", "Mi espacio", portal, { icon: "workspace" }));

    const operation = [];
    if (routeExists(routes, "/dashboard")) operation.push(leaf("dashboard", "/dashboard", "Centro de operaciones"));
    if (routeExists(routes, "/operations")) operation.push(leaf("operations", "/operations", "Control operativo"));
    if (routeExists(routes, "/data-reset")) operation.push(leaf("dataReset", "/data-reset", "Limpieza de datos"));
    if (operation.length) sections.push(category("operation", "Operación", operation, { icon: "dashboard" }));

    const training = [];
    if (routeExists(routes, "/categories")) training.push(leaf("categories", "/categories", "Categorías"));
    if (routeExists(routes, "/admin/courses")) training.push(leaf("courses", "/admin/courses", "Cursos", { match: "prefix" }));
    if (routeExists(routes, "/cohorts")) training.push(leaf("cohorts", "/cohorts", "Comisiones", { match: "prefix" }));
    if (training.length) sections.push(category("academy", "Capacitación", training, { icon: "academy" }));

    const academic = [];
    if (routeExists(routes, "/instructors")) academic.push(leaf("instructors", "/instructors", "Instructores"));
    if (routeExists(routes, "/team")) academic.push(leaf("team", "/team", "Equipo"));
    if (routeExists(routes, "/students")) academic.push(leaf("students", "/students", "Alumnos"));
    if (routeExists(routes, "/enrollments")) academic.push(leaf("enrollments", "/enrollments", "Inscripciones"));
    if (routeExists(routes, "/certificates")) academic.push(leaf("certificates", "/certificates", "Certificados"));
    if (routeExists(routes, "/calendar")) academic.push(leaf("calendar", "/calendar", "Calendario"));
    if (academic.length) sections.push(category("academic", "Académico", academic, { icon: "academic" }));

    const commercial = [];
    if (routeExists(routes, "/enrollment-orders")) commercial.push(leaf("enrollmentOrders", "/enrollment-orders", "Reservas web"));
    if (routeExists(routes, "/leads")) commercial.push(leaf("leads", "/leads", "Leads"));
    if (routeExists(routes, "/instructor-applications")) commercial.push(leaf("instructorApplications", "/instructor-applications", "Postulaciones"));
    if (routeExists(routes, "/operations/interested")) commercial.push(leaf("interested", "/operations/interested", "Interesados"));
    if (routeExists(routes, "/operations/withdrawals")) commercial.push(leaf("withdrawals", "/operations/withdrawals", "Arrepentimientos"));
    if (routeExists(routes, "/marketing")) commercial.push(leaf("marketing", "/marketing", "Campañas"));
    if (routeExists(routes, "/marketing/subscribers")) commercial.push(leaf("marketingSubscribers", "/marketing/subscribers", "Suscriptores"));
    if (routeExists(routes, "/marketing/email")) commercial.push(leaf("marketingEmail", "/marketing/email", "Email marketing"));
    if (routeExists(routes, "/promotions")) commercial.push(leaf("promotions", "/promotions", "Promociones"));
    if (routeExists(routes, "/referrals")) commercial.push(leaf("referrals", "/referrals", "Referidos"));
    if (routeExists(routes, "/influencers")) commercial.push(leaf("influencers", "/influencers", "Influencers"));
    if (routeExists(routes, "/traffic-analytics")) commercial.push(leaf("trafficAnalytics", "/traffic-analytics", "Tráfico web"));
    if (commercial.length) sections.push(category("commercial", "Comercial", commercial, { icon: "commercial" }));

    const finance = [];
    if (routeExists(routes, "/payments")) finance.push(leaf("payments", "/payments", "Finanzas y pagos"));
    if (routeExists(routes, "/settlements")) finance.push(leaf("settlements", "/settlements", "Liquidaciones"));
    if (finance.length) sections.push(category("finance", "Finanzas", finance, { icon: "finance" }));

    if (routeExists(routes, "/settings")) {
        sections.push(leaf("principal", "/settings", "Principal", {
            icon: "settings",
            emphasis: "principal",
            placement: "standalone",
        }));
    }

    return sections;
};
